import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from '../../../../ui';
import { RelatedChannel } from '../models';
import Follow from './follow';
import { TrackableElement } from './view-tracker';
import styles from './channel-header.module.scss';

interface ChannelHeaderProps {
  item: RelatedChannel;
  channelLink: string;
  follow: (id: number) => void;
  unfollow: (id: number) => void;
  onOpenChannel: (id: number) => void;
  trackableClassName?: string;
}

const ChannelHeader: React.FC<ChannelHeaderProps> = ({ item, ...props }) => {
  const { t } = useTranslation();

  return (
    <TrackableElement
      trackingId={item.id}
      trackableClassName={`${styles.layout} ${props.trackableClassName} content-channel`}
    >
      <div>
        <div className={styles.moreFrom}>{t('content.more_from')}</div>
        <div className={styles.channelHeader}>
          <Link
            href={props.channelLink}
            action="push"
            className={styles.channelName}
            aria-label={item.name}
            onClick={() => props.onOpenChannel(item.id)}
          >
            {item.name}
          </Link>
          {!item.default && (
            <Follow {...item} {...props} channelName={item.name} />
          )}
        </div>
      </div>
    </TrackableElement>
  );
};

export default ChannelHeader;
